import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Signup from '../views/Signup.vue'
import Signin from '../views/Signin.vue'
import settings from './settings'
import employees from './employees'
import inventory from './inventory'
import items from './items'
import reports from './reports'
import customers from './customers'
import workgroup from './workgroup'
import errors from "./errors"

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/signup', name: 'signup', component: Signup },
  { path: '/signin', name: 'Signin', component: Signin },
  ...settings.settings,
  ...employees.employees,
  ...inventory.inventory,
  ...items.items,
  ...reports.reports,
  ...customers.customers,
  ...workgroup.workgroups,
  ...errors.errors,
  {
    path: '/print-label', name: 'print-label', component: (
    ) => import('../views/PrintLabel.vue')
  },
  {
    path: '/print-label-all', name: 'print-label-all', component: (
    ) => import('../views/PrintLabelAll.vue')
  },
  { path: '/:other', name: 'other', component: Home },
  { path: '/:other/:other1', name: 'otherpage', component: Home }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
})

export default router
